import { clsx } from "clsx";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
};

/**
 * Helper component to display simple lists. Children should have
 * 1 or 2 direct elements.
 */
export const ListItem = ({ children, onClick, isSelected }: Props) => {
  const className = clsx("list-item text-tiny", {
    "selected": isSelected,
    "pointer": onClick
  });

  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  );
};
